import * as React from 'react';
import { currentLanguage, setCurrentLanguage } from '../currentLanguage';

import { langMap } from '@pdcplan/shared/generated/language/TeamPlan';

import './LanguageSelect.scss';
import ids from '../testing/ids';
import { SelectInput, SelectOptions } from '@pdcfrontendui/components';
import {
  LanguageCode,
  isLanguageCode,
} from '@pdcplan/shared/generated/language/TeamPlan';

export interface DispatchFromProps {
  setLanguage: (newLanguage: LanguageCode) => void;
}

type Props = DispatchFromProps & { languageCode: LanguageCode };

export default class LanguageSelect extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.options = Object.keys(langMap).map<SelectOptions>((key) => {
      const obj = langMap[key as keyof typeof langMap];
      return {
        key,
        value: obj.languageName,
      };
    });
  }
  options: SelectOptions[];

  handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const lang = event.target.value;
    if (isLanguageCode(lang)) {
      setCurrentLanguage(lang);
    }
  };

  render() {
    return (
      <SelectInput
        id={ids.Login.languageSelect}
        value={this.props.languageCode}
        label=""
        ghost
        onChange={this.handleChange}
        options={this.options}
        ariaLabel={currentLanguage.SelectLanguage}
      />
    );
  }
}
